export const STATUS_CONSTANTS = Object.freeze({
    FILE_TO_REVIEW_STATUS_CODE: 9,
    FILE_CORRECT_STATUS_CODE: 10,
    FILE_REJECT_STATUS_CODE: 11
});

export const SERVICES_CONSTANTS = Object.freeze({
    ADMIN_PATH: {
        MAIN: '/admin/management',
        AUTH: {
            MAIN: '/auth',
            LOGIN: '/login',
            REFRESH: '/refresh',
            LOGOUT: '/logout',
            FRONTEND_PERMISSIONS: '/frontend-permissions'
        },
        MANAGEMENT_WORKBIES: {
            MAIN: '/management-workbies',
            GET_ALL_PENDING_WORKBIES: '/get-all-pending',
            APPROVE_WORKBI: '/approve-workbie',
            GET_S3_FILE: '/get-s3-file',
            SAVE_OBS_PROFILE: '/save-obs-profile'
        },
        STATUS: {
            MAIN: '/status',
            STATUS_FILES: '/status-files'
        },
        HELP_REQUESTS: {
            MAIN: '/help-requests',
            GET_ALL: '',
            GET_BY_ID: '/:id',
            REPLY: '/reply',
            STATUS: '/status'
        },
        WORKBIE_PAYOUTS: {
            MAIN: '/workbie-payouts',
            WEEKLY_PENDING: '/weekly-pending',
            DETAIL: '/detail',
            PROCESS_PAYMENT: '/process-payment',
            SUMMARY: '/summary',
            PENDING: '/pending',
            PAID: '/paid',
            DETAIL_PENDING: '/detail-pending'
        },
        CATEGORIES: {
            MAIN: '/categories',
            SUBCATEGORIES: '/subcategories',
            UPLOAD_IMAGE: '/upload-image'
        },
        COUPONS: {
            MAIN: '/coupons',
            STATUS: '/status'
        },
        FINANCES: {
            MAIN: '/finances',
            DASHBOARD: '/dashboard'
        }
    },
    CATEGORIES_PATH: {
        MAIN: '/service-types',
        CATREGORIES: '/categories'
    },
    PUBLIC_CATEGORIES_PATH: {
        MAIN: '/admin/public',
        CATEGORIES: '/categories'
    }
});
